<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item label="系统编码">
        <a-input
          v-model="form.webId"
          placeholder="保存后系统自动生成"
          disabled
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="权证编号" prop="certificateNumber">
        <a-input
          v-model="form.certificateNumber"
          placeholder="请输入权证编号"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="权证类型" prop="propertyType">
            <a-select
              placeholder="请选择权证类型"
              v-model="form.propertyType"
              :not-found-content="fetching.propertyType ? undefined : null"
              @dropdownVisibleChange="propertyTypeDictionaries"
              :disabled="!isEditable"
            >
              <a-spin
                v-if="fetching.propertyType"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-else
                v-for="propertyType in dictionaries.propertyType"
                :key="propertyType.value"
              >
                {{ propertyType.note }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            v-if="form.propertyType == 3"
            label="标签"
            prop="label"
          >
            <a-select
              placeholder="请选择标签"
              v-model="form.label"
              :not-found-content="fetching.label ? undefined : null"
              @dropdownVisibleChange="propertyLabelDictionaries"
              :disabled="!isEditable"
            >
              <a-spin
                v-if="fetching.label"
                slot="notFoundContent"
                size="small"
              />
              <a-select-option
                v-else
                v-for="label in dictionaries.label"
                :key="label.value"
              >
                {{ label.note }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            v-if="form.propertyType == 2"
            label="使用权证明文件名"
            prop="useRightsFileName"
          >
            <a-input
              v-model="form.useRightsFileName"
              style="width: 100%"
              placeholder="请输入使用权证明文件名"
              :disabled="!isEditable"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item
            label="权证面积（㎡）"
            prop="certificateArea"
            extra="提示：请填写建筑面积，若无，填写宗地面积。"
          >
            <a-input
              v-model="form.certificateArea"
              style="width: 100%"
              placeholder="请输入权证面积"
              :disabled="!isEditable"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            v-if="form.propertyType == 3"
            label="权利证明文件名称"
            prop="rightsCertificateFileName"
          >
            <a-input
              v-model="form.rightsCertificateFileName"
              style="width: 100%"
              placeholder="请输入使用权证明文件名"
              :disabled="!isEditable"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="权证地址" prop="certificateAddressCode">
        <a-cascader
          v-model="form.certificateAddressCode"
          :options="options.addressCode"
          :load-data="loadData"
          placeholder="请选择权证地址"
          notFoundContent="正在加载..."
          change-on-select
          @popupVisibleChange="areaDictionaries"
          @change="onCertificateAddressChange"
          :disabled="!isEditable"
        >
          <template slot="displayRender" slot-scope="{ labels }">
            {{
              (!selectCertificateProvinceType ||
                !(options.addressCode && options.addressCode.length > 0)) &&
              form.certificateAddressCode &&
              form.certificateAddressCode.length > 0
                ? certificateAddressString
                : labels.join(" / ")
            }}
          </template>
        </a-cascader>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="权证地址详细地点" prop="certificateAddress">
        <a-input
          v-model="form.certificateAddress"
          placeholder="请输入权证地址详细地点"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24" style="margin-bottom: -10px">
      <a-form-model-item label="实际地址类型" prop="consistentWithCertificate">
        <a-radio-group
          v-model="form.consistentWithCertificate"
          :disabled="!isEditable"
          @change="onAddressTypeChange"
        >
          <a-radio :value="1">与产证地址一致</a-radio>
          <a-radio :value="2">与产证地址不一致</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="实际地址" prop="physicalAddressCode">
            <a-cascader
              v-model="form.physicalAddressCode"
              :options="options.addressCode"
              :load-data="loadData"
              placeholder="请选择实际地址"
              notFoundContent="正在加载..."
              change-on-select
              @popupVisibleChange="areaDictionaries"
              @change="onPhysicalAddressChange"
              :disabled="!isEditable || isAddressSame"
            >
              <template slot="displayRender" slot-scope="{ labels }">
                {{
                  form?.physicalAddressCode?.length > 0 &&
                  (
                    !selectPhysicalProvinceType ||
                    (isAddressSame && !selectCertificateProvinceType)
                  )
                    ? (
                        isAddressSame
                          ? certificateAddressString
                          : physicalAddressString
                      )
                    : labels.join(" / ")
                }}
              </template>
            </a-cascader>
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="实际地址详细地点" prop="physicalAddress">
            <a-input
              v-model="form.physicalAddress"
              :disabled="!isEditable || isAddressSame"
              placeholder="请输入实际地址详细地点"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <template v-if="physicalProvinceCode === '310000'">
      <a-col :span="24">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="所属地段" prop="district">
              <a-select
                placeholder="请选择所属地段"
                v-model="form.district"
                :not-found-content="fetching.district ? undefined : null"
                @dropdownVisibleChange="districtDictionaries"
                :disabled="!isEditable"
              >
                <a-spin
                  v-if="fetching.district"
                  slot="notFoundContent"
                  size="small"
                />
                <a-select-option
                  v-else
                  v-for="district in dictionaries.district"
                  :key="district.value"
                >
                  {{ district.note }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="是否涉及以下板块" prop="isCoverBlock">
              <a-radio-group
                v-model="form.isCoverBlock"
                :disabled="!isEditable"
              >
                <a-radio :value="1">是</a-radio>
                <a-radio :value="0">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-if="form.isCoverBlock == 1">
            <a-form-model-item label="所属板块" prop="block">
              <a-spin v-if="fetching.block" />
              <a-checkbox-group
                v-else
                v-model="form.block"
                style="width: 100%"
                :disabled="!isEditable"
              >
                <a-row :gutter="[0, 12]">
                  <a-col
                    :span="6"
                    v-for="item in dictionaries.block"
                    :key="item.value"
                  >
                    <a-checkbox :value="item.value">{{ item.note }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-col>
    </template>

    <a-col :span="24">
      <a-form-model-item
        label="权证用途"
        prop="assetUse"
        extra="提示：请填写房屋用途，若无，填写“/”。"
      >
        <a-input
          v-model="form.assetUse"
          placeholder="请输入权证用途"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
const LEAF_REGIONS = ["台湾省", "香港特别行政区", "澳门特别行政区"];

import {
  getPropertyType,
  getLabel,
  getProvinceList,
  getAreaList,
  getDistrict,
  getBlock,
} from "@/api/shexgrp/Dictionaries.js";

import {
  initPropertyType,
  initLabel,
  initProvinceList,
  initDistrict,
  initBlock,
} from "@/api/shexgrp/InitDictionaries.js";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    certificateAddressString: {
      type: String,
      default: undefined,
    },
    physicalAddressString: {
      type: String,
      default: undefined,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      fetching: {
        propertyType: false,
        label: false,
        district: false,
        block: false,
        obligeeType: false,
        economicType: false,
      },
      dictionaries: {
        propertyType: [],
        label: [],
        district: [],
        block: [],
      },
      options: {
        addressCode: [],
      },

      // 权证地址是否由用户选择过
      selectCertificateProvinceType: false,

      // 实际地址是否由用户选择/系统同步过
      selectPhysicalProvinceType: false,

      // 地址类型 watcher 是否完成初始化
      addressWatchInited: false,

      // 用户是否主动切换过“实际地址类型”
      addressTypeChangedByUser: false,
    };
  },

  computed: {
    isAddressSame() {
      return this.form.consistentWithCertificate == 1;
    },

    physicalProvinceCode() {
      const val = this.form.physicalAddressCode;
      if (!val) return undefined;

      if (Array.isArray(val)) {
        return val[0];
      }

      if (typeof val === "string") {
        return val.split(",")[0];
      }

      return undefined;
    },
  },

  mounted() {
    this.initPropertyTypeDictionaries();
    this.initPropertyLabelDictionaries();
    this.initDistrictDictionaries();
    this.initBlockDictionaries();
    this.initAreaDictionaries();
  },

  watch: {
    "form.consistentWithCertificate": {
      immediate: true,
      handler(val) {
        // 初始化回显时不处理，保留数据库历史实际地址
        if (!this.addressWatchInited) {
          this.addressWatchInited = true;
          return;
        }

        // 非用户主动切换，不处理
        if (!this.addressTypeChangedByUser) return;

        if (val == 1) {
          this.syncPhysicalAddressFromCertificate();
          return;
        }

        this.clearPhysicalAddress();
      },
    },

    // 权证地址变化时，如果当前为“一致”且用户已经进入联动模式，则实际地址随动
    "form.certificateAddressCode"(val) {
      if (this.isAddressSame && this.addressTypeChangedByUser) {
        this.form.physicalAddressCode = val ? [...val] : undefined;
        this.selectPhysicalProvinceType = true;
      }
    },

    "form.certificateAddress"(val) {
      if (this.isAddressSame && this.addressTypeChangedByUser) {
        this.form.physicalAddress = val || undefined;
      }
    },

    "form.isCoverBlock"(val) {
      if (val == 1) {
        this.blockDictionaries();
      }
    },
  },

  methods: {
    onAddressTypeChange() {
      this.addressTypeChangedByUser = true;
    },

    onCertificateAddressChange() {
      this.selectCertificateProvinceType = true;

      if (this.isAddressSame && this.addressTypeChangedByUser) {
        this.syncPhysicalAddressFromCertificate();
      }
    },

    onPhysicalAddressChange() {
      this.selectPhysicalProvinceType = true;
    },

    syncPhysicalAddressFromCertificate() {
      this.form.physicalAddressCode = this.form.certificateAddressCode
        ? [...this.form.certificateAddressCode]
        : undefined;

      this.form.physicalAddress = this.form.certificateAddress || undefined;

      // 同步后让实际地址 Cascader 显示当前 labels，而不是数据库 physicalAddressString
      this.selectPhysicalProvinceType = true;

      this.$nextTick(() => {
        this.$refs.baseForm?.clearValidate([
          "physicalAddressCode",
          "physicalAddress",
        ]);
      });
    },

    clearPhysicalAddress() {
      this.form.physicalAddressCode = undefined;
      this.form.physicalAddress = undefined;

      // 清空后等待用户手动选择
      this.selectPhysicalProvinceType = false;

      this.$nextTick(() => {
        this.$refs.baseForm?.clearValidate([
          "physicalAddressCode",
          "physicalAddress",
        ]);
      });
    },

    async loadPropertyTypeDictionaries(apiFn, errorMsg, visible = true) {
      if (!visible) return;
      if (this.dictionaries.propertyType.length > 0) return;
      if (this.fetching.propertyType) return;

      this.fetching.propertyType = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.dictionaries.propertyType = res.data || [];
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.propertyType = false;
      }
    },

    initPropertyTypeDictionaries() {
      return this.loadPropertyTypeDictionaries(
        initPropertyType,
        "权证类型字典初始化失败"
      );
    },

    propertyTypeDictionaries(visible) {
      return this.loadPropertyTypeDictionaries(
        getPropertyType,
        "权证类型字典加载失败",
        visible
      );
    },

    async loadPropertyLabelDictionaries(apiFn, errorMsg, visible = true) {
      if (!visible) return;
      if (this.dictionaries.label.length > 0) return;
      if (this.fetching.label) return;

      this.fetching.label = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.dictionaries.label = res.data || [];
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.label = false;
      }
    },

    initPropertyLabelDictionaries() {
      return this.loadPropertyLabelDictionaries(
        initLabel,
        "标签字典初始化失败"
      );
    },

    propertyLabelDictionaries(visible) {
      return this.loadPropertyLabelDictionaries(
        getLabel,
        "标签字典加载失败",
        visible
      );
    },

    async loadDistrictDictionaries(apiFn, errorMsg, visible = true) {
      if (!visible) return;
      if (this.dictionaries.district.length > 0) return;
      if (this.fetching.district) return;

      this.fetching.district = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          this.dictionaries.district = res.data || [];
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.district = false;
      }
    },

    initDistrictDictionaries() {
      return this.loadDistrictDictionaries(
        initDistrict,
        "所属地段字典初始化失败"
      );
    },

    districtDictionaries(visible) {
      return this.loadDistrictDictionaries(
        getDistrict,
        "所属地段字典加载失败",
        visible
      );
    },

    async loadBlockDictionaries(apiFn, errorMsg) {
      if (this.dictionaries.block.length > 0) return;
      if (this.fetching.block) return;

      this.fetching.block = true;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          const list = res.data || [];
          this.dictionaries.block = this.sortBlockList(list);
        }
      } catch (err) {
        console.error(errorMsg, err);
      } finally {
        this.fetching.block = false;
      }
    },

    initBlockDictionaries() {
      return this.loadBlockDictionaries(initBlock, "所属板块字典初始化失败");
    },

    blockDictionaries() {
      return this.loadBlockDictionaries(getBlock, "所属板块字典加载失败");
    },

    sortBlockList(list) {
      const TOP_SET = new Set(["南北转型板块(宝山、金山)"]);
      const BOTTOM_SET = new Set([
        "五大新城板块(嘉定、青浦、松江、奉贤、南汇，包含吴淞创新城板块)",
      ]);

      return list.slice().sort((a, b) => {
        const aTop = TOP_SET.has(a.note);
        const bTop = TOP_SET.has(b.note);
        if (aTop && !bTop) return -1;
        if (!aTop && bTop) return 1;

        const aBottom = BOTTOM_SET.has(a.note);
        const bBottom = BOTTOM_SET.has(b.note);
        if (aBottom && !bBottom) return 1;
        if (!aBottom && bBottom) return -1;

        return 0;
      });
    },

    async loadAreaDictionaries(apiFn, errorMsg, visible = true) {
      if (!visible) return;
      if (this.options.addressCode.length > 0) return;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          setTimeout(() => {
            const list = (res.data || []).map((item) => ({
              label: item.XZQYMC,
              value: item.XZQYDM,
              isLeaf: LEAF_REGIONS.includes(item.XZQYMC),
            }));

            this.options.addressCode = this.sortAreaList(list);
          }, 300);
        }
      } catch (e) {
        console.error(errorMsg, e);
      }
    },

    initAreaDictionaries() {
      return this.loadAreaDictionaries(initProvinceList, "省份列表初始化失败");
    },

    areaDictionaries(visible) {
      return this.loadAreaDictionaries(
        getProvinceList,
        "省份列表加载失败",
        visible
      );
    },

    sortAreaList(list) {
      const CURRENCY_PRIORITY = {
        北京: 1,
        上海: 2,
      };

      return list.slice().sort((a, b) => {
        const pa = CURRENCY_PRIORITY[a.label] || 999;
        const pb = CURRENCY_PRIORITY[b.label] || 999;
        return pa - pb;
      });
    },

    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];

      targetOption.loading = true;

      try {
        const res = await getAreaList({
          sjxzqydm: targetOption.value,
        });

        if (res?.code === "200") {
          targetOption.children = (res.data || []).map((item) => ({
            label: item.XZQYMC,
            value: item.XZQYDM,
            isLeaf: selectedOptions.length >= 2,
          }));

          this.options.addressCode = [...this.options.addressCode];
        }
      } catch (e) {
        console.error("级联地址加载失败", e);
      } finally {
        targetOption.loading = false;
      }
    },
  },
};
</script>

<style>
</style>